
















import Vue from 'vue'
import InquiryFormContainer from '@/containers/Inquiry/Form'
import InquiryConfirmContainer from '@/containers/Inquiry/Confirm'
import InquiryCompleteContainer from '@/containers/Inquiry/Complete'
import CreateInquiryUseCase from '@/usecases/inquiry/CreateInquiryUseCase'
import { IInquirySeed } from '@/entities/Inquiry'

interface IData {
  /**
   * 1. お問い合わせ
   * 2. お問い合わせ内容確認
   * 3. お問い合わせ完了
   */
  step: 1 | 2 | 3
  fields: IInquirySeed | null
}

export default Vue.extend({
  components: {
    InquiryFormContainer,
    InquiryConfirmContainer,
    InquiryCompleteContainer
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    // Only for dev use like showing stories
    devProps: {
      type: Object as () => {
        step?: IData['step']
      },
      default: null
    }
  },
  data(): IData {
    return {
      step: 1,
      fields: null
    }
  },
  created() {
    const devProps = this.devProps
    if (devProps) {
      if (devProps.step) {
        this.step = devProps.step
      }
    }
  },
  methods: {
    handleAccountFormChange(params: IInquirySeed) {
      this.fields = {
        ...this.fields,
        ...params
      }
      this.step = 2
      scrollTo(0, 0)
    },
    handleSubmitSuccess() {
      this.step = 3
      scrollTo(0, 0)
    },
    async submit() {
      const usecase = new CreateInquiryUseCase({
        snapsnapGateway: this.$snapsnapGateway
      })
      const fields = this.fields
      if (!fields) return

      try {
        await usecase.execute(fields)
        this.handleSubmitSuccess()
      } catch (e) {
        this.$toastRepository.addQueue({
          type: 'error',
          text: '入力内容にエラーがあります。ご確認ください'
        })
      }
    }
  }
})
